(function () {
  'use strict';

  /* @ngdoc object
   * @name annualLeaveBidding
   * @description
   *
   */
  angular
    .module('annualLeaveBidding', [
      'ui.router'
    ]);
}());
